
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as CompassIconComponent } from "./compass-icon.svg";

export const CompassIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <CompassIconComponent {...props} />;
};
